/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import SwitchField from "components/SwitchField";
import SelectField from "components/SelectField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Fields2 from "./components/field2";
import form2 from "./schema/form2";
import initialValues2 from "./schema/initialValues2";
import validation2 from "./schema/validations2";
import Table2 from "./components/table2";
import Fields3 from "./components/field3";
import form3 from "./schema/form3";
import initialValues3 from "./schema/initialValues3";
import validation3 from "./schema/validations3";
import Table3 from "./components/table3";
import Fields4 from "./components/field4";
import form4 from "./schema/form4";
import initialValues4 from "./schema/initialValues4";
import validation4 from "./schema/validations4";
import Table4 from "./components/table4";

export default function FinancialReport01() {
  const { formId, formField } = form;
  const { formId2, formField2 } = form2;
  const { formId3, formField3 } = form3;
  const { formId4, formField4 } = form4;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([
    { name: "KQHĐSXKD", checked: false },
    { name: "LCTTTT", checked: false },
    { name: "LCTTGT", checked: false },
  ]);

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Bảng cân đối kế toán (Mẫu số B-01/DN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối cho doanh nghiệp đáp ứng giả định hoạt động liên tục)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo Thông tư số 200/2014/TT-BC Ngày 22/12/2014 của Bộ tài chính)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Tại ngày 31 tháng 12 năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo kết quả hoạt động sản xuất kinh doanh (Mẫu số B 02 - DN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo Thông tư số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues2}
              validationSchema={validation2}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId2} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField2,
                      errors,
                    }}
                  />
                  <Table2
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Lưu"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Lưu chuyển tiền tệ (Theo phương pháp trực tiếp) (Mẫu số B 03 - DN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo Thông tư số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues3}
              validationSchema={validation3}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId3} autoComplete="off">
                  <Fields3
                    formData={{
                      values,
                      touched,
                      formField3,
                      errors,
                    }}
                  />
                  <Table3
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 3 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Lưu chuyển tiền tệ (Theo phương pháp gián tiếp) (Mẫu số B 03 - DN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo Thông tư số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues4}
              validationSchema={validation4}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId4} autoComplete="off">
                  <Fields4
                    formData={{
                      values,
                      touched,
                      formField4,
                      errors,
                    }}
                  />
                  <Table4
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
const auditOpinionOption = [
  { value: "Ý kiến trái ngược", label: "Ý kiến trái ngược" },
  { value: "Ý kiến từ chối đưa ra ý kiến", label: "Ý kiến từ chối đưa ra ý kiến" },
  { value: "Ý kiến ngoại trừ", label: "Ý kiến ngoại trừ" },
  { value: "Ý kiến chấp nhận toàn phần", label: "Ý kiến chấp nhận toàn phần" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxpayersName,
    taxpayersId,

    unit,
    bctc,
    htldl,
    auditOpinion,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayersName.name}
            label={taxpayersName.label}
            value={values.taxpayersName}
            error={errors.taxpayersName && touched.taxpayersName}
            success={values.taxpayersName?.toString().length > 0 && !errors.taxpayersName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayersId.name}
            label={taxpayersId.label}
            value={values.taxpayersId}
            error={errors.taxpayersId && touched.taxpayersId}
            success={values.taxpayersId?.toString().length > 0 && !errors.taxpayersId}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={unit.name}
            label={unit.label}
            value={values.unit}
            error={errors.unit && touched.unit}
            success={values.unit?.toString().length > 0 && !errors.unit}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={bctc.name} label={bctc.label} value={values.bctc} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={htldl.name} label={htldl.label} value={values.htldl} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SelectField
            options={auditOpinionOption}
            type={auditOpinion.type}
            label={auditOpinion.label}
            name={auditOpinion.name}
            value={values.auditOpinion}
            placeholder={auditOpinion.placeholder}
            error={errors.auditOpinion && touched.auditOpinion}
            success={values.auditOpinion.length > 0 && !errors.auditOpinion}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
